(function() {

    'use strict';

    angular.module('app').
    controller('CarriersZonePostcodeFilesController', CarriersZonePostcodeFilesController);

    CarriersZonePostcodeFilesController.$inject = ['Carrier', 'CarrierZonePostcodeFileTableService', '$location','$routeParams'];

    function CarriersZonePostcodeFilesController(Carrier, CarrierZonePostcodeFileTableService, $location, $routeParams) {
        var vm = this;
        let carrierProfileId = $routeParams.carrierProfileId;
        init();

        function init() {
            let zonePostcodeFileTable = new CarrierZonePostcodeFileTableService(carrierProfileId);
            vm.zonePostcodeFiles = zonePostcodeFileTable.tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/CarriersZonePostcodeFilesController.js